import React, { useState } from 'react'

import useAnalyticsComponentViewed from 'hooks/useAnalyticsComponentViewed'
import { POTENTIAL_CONTENT, POTENTIAL_SECTION } from 'utils/testing/testIDs'

import { OPTIONS, SECTION_NAMES, baseAnalyticsOptions } from '../analytics'
import { ArticleButton } from '../shared/ArticleButton/ArticleButton'
import {
  Container,
  Content,
  InteractiveBackground,
} from '../shared/SectionDetails'
import { Chart } from './Chart/Chart'
import { Details } from './Details'
import { PotentialContext } from './PotentialContext'

export const Potential = ({
  age,
  ageOfTransfer,
  beneficiaryId,
  currentBalance,
  recurringInvestmentSettings,
  smartDepositAmount,
}: {
  age: number
  ageOfTransfer: number
  beneficiaryId: string
  currentBalance: number
  recurringInvestmentSettings: {
    amount: number
    frequency: string
  }
  smartDepositAmount?: number
}): React.ReactElement => {
  const inViewContainerRef = useAnalyticsComponentViewed({
    action: 'Viewed',
    payload: {
      ...baseAnalyticsOptions,
      ...OPTIONS.POTENTIAL,
      beneficiaryId,
      event_description: 'Early Quarterly Recaps Potential Section Viewed',
      object: 'Screen',
      object_name: 'earlyQuarterlyRecapsPotentialSection',
    },
  })

  const [values, setValues] = useState({
    projectedValue: '$0',
    selectedAge: ageOfTransfer,
    netInvestments: '$0',
    returnValue: '$0',
  })

  return (
    <PotentialContext.Provider
      value={{
        ...values,
        onChange: setValues,
      }}
    >
      <Container data-testid={POTENTIAL_SECTION} ref={inViewContainerRef}>
        <Content data-testid={POTENTIAL_CONTENT}>
          <ArticleButton
            beneficiaryId={beneficiaryId}
            section={SECTION_NAMES.POTENTIAL}
          />
          <Details />
          <InteractiveBackground>
            <Chart
              age={age}
              ageOfTransfer={ageOfTransfer}
              currentBalance={currentBalance}
              recurringInvestmentSettings={recurringInvestmentSettings}
              smartDepositAmount={smartDepositAmount}
            />
          </InteractiveBackground>
        </Content>
      </Container>
    </PotentialContext.Provider>
  )
}
